export default function() {
   const root = document.getElementById( "zskstat-browser-app" );
   const module = root.getAttribute( "data-module" )
   return module;
}